import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dashboard from './components/Dashboard';
import Routines from './components/Routines';
import Register from './components/Register';
import Members from './components/Members';
import Sessions from './components/Stats';
import ManualLogin from './components/ManualLogin';
import PaymentOptions from './components/PaymentOptions';
import Reports from './components/Reports';
import MemberAttendanceTracker from './components/MemberAttendanceTracker';
import Data from './components/Data';
import Finances from './components/Finances';
import RoutineCards from './components/RoutineCards';

// Cambiar a false cuando se regularice el saldo pendiente.
const SYSTEM_BLOCKED = false;

function SystemBlocked() {
  return (
    <main style={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      padding: '24px',
      backgroundColor: '#f8f9fa'
    }}>
      <section style={{
        width: '100%',
        maxWidth: '520px',
        padding: '36px',
        border: '1px solid #f5c2c7',
        borderRadius: '10px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
        color: '#842029',
        textAlign: 'center'
      }}>
        <h1 style={{ marginTop: 0, fontSize: '26px' }}>Sistema bloqueado</h1>
        <p style={{ marginBottom: '12px', fontSize: '17px' }}>
          El acceso se encuentra suspendido por un pago pendiente.
        </p>
        <p style={{ margin: 0 }}>
          Regularizá el saldo para reanudar el uso del sistema.
        </p>
      </section>
    </main>
  );
}

function App() {
  if (SYSTEM_BLOCKED) {
    return <SystemBlocked />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/register" element={<Register />} />
          <Route path="/members" element={<Members />} />
          <Route path="/routines" element={<Routines />} />
          <Route path="/routine-cards" element={<RoutineCards />} />
          <Route path="/stats" element={<Sessions />} />
          <Route path="/login" element={<ManualLogin />} />
          <Route path="/payment" element={<PaymentOptions />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/assistance" element={<MemberAttendanceTracker />} />
          <Route path="/data" element={<Data />} />
          <Route path="/finances" element={<Finances />} />
        </Routes>
      </div>
    </Router>
  );
}


export default App;
